import orson from '../assets/media/images/orsan.png';
import nagarajan from '../assets/media/images/nagaranjan.png';
import sandeep from '../assets/media/images/sandeep.png';
import mithil from '../assets/media/images/mithil.png';
import manesh from '../assets/media/images/manesh.png';
import hitender from '../assets/media/images/hitender.png';

export const workspaces = [
    {
        header: "AI in Cyber Threat Intelligence",
        content:
            "Global Cyber Threat Intelligence (GCTI) offers Threat Research Reports...",
        version: 1,
        lastUpdated: "22nd Jan 2024",
        published: "22nd Jan 2024",
        description: `Global Cyber Threat Intelligence (GCTI) offers Threat Research Reports Service to clients covering Strategic, Tactical, Technical, and Operational intel in the form of Weekly Digest, Ad-Hoc Emerging threat Advisory, and Monthly Executive Reports. CTI GenAI tool has automated the process of report creation by infusing GenAI which has helped in reducing the time & manual efforts spent by analyst in analyzing the threat intel and creation of reports. Automated Risk Score assignment for threat is also calculated which is tailored to client profile through an AI model to help speed up decision making and remediation stepsProduct Requirement Document Creation:
        Input business cases to generate product requirement documents using tailored templates.
        `,
        benefits: `CTI analysts take 2-3 days to research emerging cyber threats and manually create reports, including global context, execution analysis, technical details, and MITRE ATT&CK mapping, before sharing with clients. This process delays the distribution of flash reports. The CTI GenAI solution fast tracks this process.`,
        savings: `
        <div>Emerging Threat 20,000</div>
        <div>Weekly Report : 260,000</div>
        <div>Monthly Report: 65,000</div>
        <div>Total Yearly Saving: 345,000</div>
        `,
        contact: [{
            name: "Orson Ka'ili",
            email: "orson.kaili@ey.com",
            image: orson
        }, {
            name: "Nagarajan Haridas",
            email: "Nagarajan.Haridas@gds.ey.com",
            image: nagarajan
        }],
    },
    {
        header: "GenAI based Penetration Testing Reports",
        content:
            "ASC - Advanced Security Center is EY's Advanced Security Center... ",
        version: 1,
        lastUpdated: "22nd Jan 2024",
        published: "22nd Jan 2024",
        description: `ASC - Advanced Security Center is EY's Advanced Security Center (ASC Cloud) is an extensive, adaptable cloud-based testing platform that helps mitigate risk exposure related to potential operational disruptions or data breaches caused by cyber-attacks on critical systems. With ASC Cloud, each ASC can have a virtual machine set up within
        a dedicated Azure tenant (with one or more testing environments) that can be utilized to perform Attack and Penetration (A&P) testing in the cloud. The transition to the cloud, powered by Microsoft Azure, allows EY ASC Cloud to standardize the A&P testing tools and methodology across all teams, enhancing the services provided by ASC, offering flexibility to our testing teams, and enabling us to deliver superior service to our clients.`,
        benefits: `Manual preparation of penetration test reports, which involves fetching data from various vulnerability databases, assigning risk scores, and other tasks, is a lengthy and error-prone process that requires multiple QA/review cycles. The GenAI based Penetration Testing Reports solution fast tracks this process`,
        savings: `
            <div>Minimum Savings per report: $1000</div>
            <div>Average Pen Test Engagement per month: $15,000</div>
            <div>Total Yearly Saving : $180,000</div>`,
        contact: [{
            name: "Orson Ka'ili",
            email: "orson.kaili@ey.com",
            image: orson
        }, {
            name: "Nagarajan Haridas",
            email: "Nagarajan.Haridas@gds.ey.com",
            image: nagarajan
        }, {
            name: "Sandeep A Motwani",
            email: "Sandeep.Motwani@gds.ey.com",
            image: sandeep
        }]
    },
    {
        header: "AI in Privilege Access Research And Inventory System",
        content:
            "PARIS is an in-house tool for privileged access management (PAM), ...",
        version: 1,
        lastUpdated: "22nd Jan 2024",
        published: "22nd Jan 2024",
        description: `
        <div>PARIS is an in-house tool for privileged access management (PAM), offering insights into unseen risks to critical data by identifying excessive access and overprivileged accounts. It enables clients to pinpoint and remediate data vulnerabilities, ensuring the protection of sensitive information through detailed analytics on user accounts, entitlements, and groups.</div>
        <ul>
            <li>Connects to target systems from client environment using built-in connectors.</li>
            <li>Gathers the inventories of accounts, roles, entitlements.</li>
            <li>Data is stored in centralized database.</li>
            <li>Allows EY users to perform tagging, correlation and mapping.</li>
            <li>Provides visibility to what accounts exist in client environment, which of them are privileged accounts</li>
        </ul>
        `,
        nlpSearch: `In the context of managing privileged access within complex IT infrastructures, PARIS currently lacks an intuitive and efficient method for users to query and retrieve information about privileged accounts, access rights, and associated risks`,
        nlpSearchBenefits: `In the context of managing privileged access within complex IT infrastructures, PARIS currently lacks an intuitive and efficient method for users to query and retrieve information about privileged accounts, access rights, and associated risks`,
        recommendationEngine: `In the rapidly changing IT environment, the standards for privileged accounts and their risks are constantly shifting, necessitating regular updates to the criteria rather than relying on static, inflexible rules. Currently, PARIS relies on a predetermined rule set for issuing recommendations and assessing risk, which needs to evolve to stay effective.`,
        benefits: `NLP-powered chatbot that can understand and process natural language queries, providing users with quick, relevant, and accurate search results.`,
        contact: [{
            name: "Orson Ka'ili",
            email: "orson.kaili@ey.com",
            image: orson
        }, {
            name: "Nagarajan Haridas",
            email: "Nagarajan.Haridas@gds.ey.com",
            image: nagarajan
        }, {
            name: "Mithhil Arora",
            email: "Mithhil.Arora@gds.ey.com",
            image: mithil
        }]
    },
    {
        header: "EY CASPER",
        content:
            "EY CASPER, an Al enabled platform that provides everything as a, ...",
        version: 1,
        lastUpdated: "22nd Jan 2024",
        published: "22nd Jan 2024",
        description: `
        <div>EY CASPER, an Al enabled platform that provides everything as a code to secure the cloud pipelines and achieves complete automation on cloud pipelines.</div>
        `,
        keyFeaturesOfCasper: `
        <ul>
            <li>Deployable security templates as per industry standards Codify building blocks and Runtime policies.</li>
            <li>Automate configuration drift management and remediation</li>
            <li>Scalable, Secure and modular Cloud Security automation back by GenAl With Al and converting everything as a code CASPER helps to scale the infrastructure easily and ensure consistent compliance with defined industry standards and internal organization policies</li>
        </ul>`,
        nlpSearchBenefits: `The solution solves a pressing assurance and automation problem for clients. CASPER helps our customers, throughout the Cloud lifecycle to mitigate some of the key risks faced by organization, like 
         <ul>
            <li>Lack of control over who can access sensitive data. </li>
            <li>Inability to maintain Continuous regulatory compliance</li>
            <li>Security weak points and failures of critical services</li>
            <li>Lack of Security automation</li>
        </ul>`,
        valueProp: `
         <ul>
            <li>Compliance assurance across security standards and regulations</li>
            <li>Automated deployment of infrastructure as per security baseline configurations</li>
            <li>Custom assessments / policy check on cloud infastrcuture </li>
            <li>Embedded policy as a code framework to enable fine grained, condition based policy decisions</li>
        </ul>`,
        businessBenefits: `
        <ul>
           <li>Approx. 60% reduction in detection and prevention of cyber risks</li>
           <li>5X times faster deployments</li>
           <li>3X times enhanced Quality</li>
       </ul>`,
        contact: [{
            name: "Orson Ka'ili",
            email: "orson.kaili@ey.com",
            image: orson
        }, {
            name: "Manesh J Mani",
            email: "manesh.mani@gds.ey.com",
            image: manesh
        }, {
            name: "Hitender Saxena",
            email: "hitender.saxena@gds.ey.com",
            image: hitender
        }]
    },
    {
        header: "PIA",
        content:
            "A Privacy Impact Assessment (PIA) or Data Protection Impact Assessment (DPIA), ...",
        version: 1,
        lastUpdated: "22nd Jan 2024",
        published: "22nd Jan 2024",
        description: `
        <div>A Privacy Impact Assessment (PIA) or Data Protection Impact Assessment (DPIA) is a systematic and comprehensive analysis of the privacy implications of a proposed project or activity. It is used to identify and assess privacy risks and to determine the appropriate measures to mitigate those risks. The instrument for a PIA or DPIA was introduced with the General Data Protection Regulation (GDPR).</div>
        `,
        nlpSearchBenefits: `
        <ul>
            <li>PIA can be integrated with EY ASSESS for automated validation for Privacy impact assessment​</li>
            <li>With PIA tool, validation part of the responses during privacy impact assessment can be automated which reduces the human involvement by at least 40%</li>
        </ul>`,
        businessBenefits: `
        <ul>
           <li>This EY accelerator will be able to deliver more efficient and timely PIA service to clients.​</li>
           <li>EY professionals across the globe can leverage it to reduce the effort involved in drafting and reviewing  the PIA reports.​
Increase EY win ratio by providing competitive rates</li>
       </ul>`,
        contact: [{
            name: "Orson Ka'ili",
            email: "orson.kaili@ey.com",
            image: orson
        },
        {
            name: "Hitender Saxena",
            email: "hitender.saxena@gds.ey.com",
            image: hitender
        }]
    },
    {
        header: "C@iR",
        content:
            "C@iR(Cybersecurity AI Respondent) is an AI powered ...",
        version: 1,
        lastUpdated: "22nd Jan 2024",
        published: "22nd Jan 2024",
        description: `
        <div>C@iR(Cybersecurity AI Respondent) is an AI powered Cybersecurity solution designed to enhance the efficiency and effectiveness of defenders, enabling improved security outcomes  at machine speed and scale.</div>
        `,
        nlpSearchBenefits: `
        <ul>
            <li>Alleviate respondents from knowing the underlying technology and focus on the (KQL, DB structure, etc.)​</li>
            <li>Address both internal and external issues such as consistency on quality of investigation</li>
            <li>Quick Adoption: A simple and familiar interface reduces the learning curve, allowing analysts to start using the tool effectively right away.</li>
            <li>Enhanced User Experience: A user-friendly design minimizes frustration and errors, improving overall satisfaction and productivity among cyber professionals.</li>
        </ul>`,
        businessBenefits: `
        <ul>
           <li>Manual effort cost for *2K (base) alerts per month is amounting to $33.4K, with CAIR intervention, service cost will be cut-down to $16.7K​</li>
           <li>With CAIR intervention, service cost will be cut-down to $16.7K FTE requirement in manual approach is 6.33 for *base alerts Post C@iR, released FTE will be 3.17</li>
           <li>50% faster time response on analysis, investigation, and Digital Forensics and Incident Response (DFIR) work</li>
           <li>20% removal of dependency from user</li>
       </ul>`,
        contact: [{
            name: "Orson Ka'ili",
            email: "orson.kaili@ey.com",
            image: orson
        }]
    },
    {
        header: "MTRAC",
        content:
            "MTRAC (MITRE Threat Response Analyst Copilot) revolutionizes cybersecurity operation ...",
        version: 1,
        lastUpdated: "22nd Jan 2024",
        published: "22nd Jan 2024",
        description: `
        <div>MTRAC (MITRE Threat Response Analyst Copilot) revolutionizes cybersecurity operations with its Al-driven, predictive system. It expertly merges diverse data from SIEM, XDR, and Threat Intelligence, offering unparalleled insight. The heart of MTRAC is its advanced ML-powered analysis engine, predicting threats proactively and streamlining decision-making with a unique confidence scoring mechanism. Designed to mitigate analyst biases and simplify complex data interpretations, MTRAC ensures accurate, objective threat assessments through a user-centric interface.</div>
        `,
        nlpSearchBenefits: `
        <ul>
            <li>MTRAC provides AI-Powered Predictive Analysis feature for proactive threat response.​​</li>
            <li>Ensures Bias Reduction: Neutral, data-driven algorithms for objective analysis.​</li>
            <li>With the ML feature it evaluates prediction reliability, enhancing decision-making.</li>
        </ul>`,
        businessBenefits: `
        <ul>
           <li>AI-Powered Predictive Analysis: Harnesses advanced machine learning for proactive threat response.​</li>
           <li>Bias Reduction: Neutral, data-driven algorithms for objective analysis.​</li>
           <li>Confidence Scoring: Evaluates prediction reliability, enhancing decision-making.​</li>
           <li>User-Friendly Design: Accessible interface for analysts at all skill levels.​</li>
           <li>Customizable & Scalable: Adapts to varying organizational security needs.​</li>
       </ul>`,
        contact: [{
            name: "Orson Ka'ili",
            email: "orson.kaili@ey.com",
            image: orson
        }]
    },
    {
        header: "HAPT",
        content:
            "HAPT.ai is an AI-powered Hyper Automated Penetration Testing solution ...",
        version: 1,
        lastUpdated: "22nd Jan 2024",
        published: "22nd Jan 2024",
        description: `
        <div>HAPT.ai is an AI-powered Hyper Automated Penetration Testing solution. It automates the penetration testing process, from predicting vulnerabilities and prioritizing test cases to executing various tool-based tests seamlessly.</div>
        `,
        nlpSearchBenefits: `
        <ul>
            <li>A custom approach that prioritizes each test case, thereby ensuring appropriate weight is allocated according to their relevance and potential risk impact. This not only maximizes efficiency but also reduces the time spent on irrelevant testcases.​​</li>
            <li>HAPT.ai provides a seamless testing solution. With its unique features and predictive capabilities, it streamlines the testing process, making it not only more efficient and result-oriented but also less time consuming. This not only reduces the workload on testers but also enhances their ability to safeguard the systems more effectively​</li>
            <li>The predictive analysis of vulnerabilities offered by HAPT.ai enables testers to adopt a more targeted approach. By anticipating potential threats, testers can focus their efforts on addressing the most significant vulnerabilities, thus enhancing the overall security posture.</li>
        </ul>`,
        businessBenefits: `
        <ul>
           <li>Smart checklist prioritization and promises to reduce human dependency by 40%​</li>
           <li>40% Reduced test time remarkably improve accuracy even with a large scope of applications.​</li>
       </ul>`,
        contact: [{
            name: "Orson Ka'ili",
            email: "orson.kaili@ey.com",
            image: orson
        }]
    },
    {
        header: "ISecMapper",
        content:
            "Automates Cyber Risk assessments including TPSA, Vendor, contract management, ...",
        version: 1,
        lastUpdated: "22nd Jan 2024",
        published: "22nd Jan 2024",
        description: `
        <div>ISecMapper : Automates Cyber Risk assessments including TPSA, Vendor, contract management, evidence mapping. Supporting end to end cyber assessment capabilities.</div>
        `,
        nlpSearchBenefits: `
        <ul>
            <li>Make use of various Frameworks such as NIST, ISO 27001, CIS benchmarks to provide the appropriate recommendation based on the query.​</li>
            <li>Library of integration scripts which can be integrated into the pipeline for enabling live control mapping.​</li>
            <li>Customizable to address multiple use cases across domains</li>
        </ul>`,
        businessBenefits: `
        <ul>
           <li>50% Reduced human and skill dependency</li>
           <li>30% reduction in operational expenses. ​</li>
           <li>Increased accuracy even with large number of queries​</li>
           <li>40% reduction of time</li>
       </ul>`,
        contact: [{
            name: "Orson Ka'ili",
            email: "orson.kaili@ey.com",
            image: orson
        },
        {
            name: "Hitender Saxena",
            email: "hitender.saxena@gds.ey.com",
            image: hitender
        }]
    },
    {
        header: "Cyber Pioneer",
        content:
            "Cyber Pioneer: EY Cyber pioneer is an accelerator that provides Cloud optimized and secure way...",
        version: 1,
        lastUpdated: "22nd Jan 2024",
        published: "22nd Jan 2024",
        description: `
        <div>Cyber Pioneer: EY Cyber pioneer is an accelerator that provides Cloud optimized and secure way of automating the process of security policies generation from a variety of security standard frameworks using Generative AI to develop policies from scratch and also to preform gap assessment on existing policies against several security frameworks like NIST, CIS etc.</div>
        `,
        nlpSearchBenefits: `
        <ul>
            <li>Pioneer will help in  ~40% manual effort reduction for management as it automates the gap assessment process for policies.​​</li>
            <li>This can be done for any type of policies (not just Cyber one).​</li>
        </ul>`,
        businessBenefits: `
        <ul>
           <li>Enable the 2x growth opportunity for EY by moving expected average engagement margin to increase from 20% to 35% (or increase wins ratio; with competitive rates).​</li>
           <li>~40% manual effort reduction for management.​</li>
           <li>Provides smart high-level recommendations based on the various security frameworks available.​</li>
       </ul>`,
        contact: [{
            name: "Orson Ka'ili",
            email: "orson.kaili@ey.com",
            image: orson
        },
        {
            name: "Hitender Saxena",
            email: "hitender.saxena@gds.ey.com",
            image: hitender
        }]
    },
];
